module.exports = __webpack_public_path__ + "assets/img/8-2.82186959.png";